import React, { Component } from 'react';
interface ErrorBoundaryProps {
  children: React.ReactNode;
}
interface ErrorBoundaryState {
  hasError: boolean;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError(): ErrorBoundaryState {
    return {
      hasError: true
    };
  }
  componentDidCatch(error: unknown, info: unknown) {
    // Surface the error for debugging without taking down the whole page.
    console.error('Render error capturado por ErrorBoundary:', error, info);
  }
  handleReload = () => {
    this.setState({
      hasError: false
    });
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };
  render() {
    if (this.state.hasError) {
      return <div className="min-h-screen w-full bg-cream flex items-center justify-center px-6 py-16 text-center" data-id="element-328">
          <div className="max-w-sm" data-id="element-329">
            <div className="mx-auto mb-5 w-14 h-14 rounded-full bg-combo-green/10 flex items-center justify-center text-2xl" data-id="element-330">
              ⚠️
            </div>
            <h1 className="font-serif font-bold text-2xl text-ink mb-2" data-id="element-331">
              Algo salió mal
            </h1>
            <p className="text-ink-light text-sm mb-6 leading-relaxed" data-id="element-332">
              Tuvimos un problema al mostrar esta sección. Volvé a cargar la
              página para seguir con tu compra.
            </p>
            <button type="button" onClick={this.handleReload} className="bg-combo-green text-white px-6 py-3 rounded-full font-bold text-sm hover:bg-combo-green/90 transition-colors shadow-glow" data-id="element-333">
              Recargar página
            </button>
          </div>
        </div>;
    }
    return this.props.children;
  }
}